import React from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Category from "./Category";
import CategoryService from "./CategoryService";

const tabs = [{ label: "Service Category", value: "service_category" }];

const CompanyCatalogue = () => {
  const activeTab = useSelector((state) => state.activeTab.tabs);

  return (
    <NavigationDrawer>
      {activeTab.company_catalogue === "service_category" ? (
        <Category />
      ) : activeTab.company_catalogue === "category_details" ? (
        <CategoryService />
      ) : null}
    </NavigationDrawer>
  );
};

export default CompanyCatalogue;
